.list {
  --dds-progress-tracker-connector-width: 1px;
  --dds-progress-tracker-item-number-size: 1.75rem;
  --dds-progress-tracker-item-margin: calc(
    (var(--dds-progress-tracker-item-number-size) / 2) -
      (var(--dds-progress-tracker-connector-width) / 2)
  );
}

.list-item:not(:first-child)::before {
  content: '';
  display: block;
}

.list-item--column:not(:first-child)::before {
  border-right: var(--dds-progress-tracker-connector-width) solid
    var(--dds-color-border-default);
  width: var(--dds-progress-tracker-connector-width);
  height: 1.125rem;
  margin-left: var(--dds-progress-tracker-item-margin);
  margin-bottom: var(--dds-spacing-x0-125);
}

.list-item--row:not(:first-child)::before {
  border-top: var(--dds-progress-tracker-connector-width) solid
    var(--dds-color-border-default);
  height: var(--dds-progress-tracker-connector-width);
  width: 1.875rem;
  margin-top: var(--dds-progress-tracker-item-margin);
  margin-right: var(--dds-spacing-x0-5);
}

.item-button {
  grid-template-columns: var(--dds-progress-tracker-item-number-size) 1fr;
  cursor: pointer;

  @media (prefers-reduced-motion: no-preference) {
    transition: all var(--dds-motion-micro-state);
  }

  &:hover > .item-number--active-incomplete {
    background-color: var(--dds-color-surface-action-resting);
    border-color: var(--dds-color-border-action-default);
    color: var(--dds-color-text-on-action);
  }

  &:hover > .item-number--inactive-incomplete {
    background-color: var(--dds-color-surface-hover-default);
    border-color: var(--dds-color-border-action-hover);
    color: var(--dds-color-text-action-hover);
  }

  &:hover > .item-number--active-completed,
  &:hover > .item-number--inactive-completed {
    background-color: var(--dds-color-surface-action-hover);
    border-color: var(--dds-color-border-action-hover);
    color: var(--dds-color-icon-on-action);
  }

  &:disabled {
    cursor: not-allowed;
  }
}

.item-div {
  cursor: default;
}

.item-number {
  border-radius: var(--dds-border-radius-rounded);
  z-index: var(--dds-zindex-absolute-element);
  font-weight: var(--dds-font-weight-bold);
  border: 2px solid;
  height: var(--dds-progress-tracker-item-number-size);
  width: var(--dds-progress-tracker-item-number-size);

  @media (prefers-reduced-motion: no-preference) {
    transition:
      background-color var(--dds-motion-micro-state),
      border-color var(--dds-motion-micro-state),
      color var(--dds-motion-micro-state);
  }
}

.item-number--disabled {
  background-color: var(--dds-color-surface-default);
  border-color: var(--dds-color-border-default);
  color: var(--dds-color-text-subtle);
}

.item-number--active-incomplete,
.item-number--active-completed,
.item-number--inactive-completed {
  background-color: var(--dds-color-surface-action-resting);
  border-color: var(--dds-color-border-action-default);
  color: var(--dds-color-text-on-action);
}

.item-number--inactive-incomplete {
  background-color: var(--dds-color-surface-default);
  border-color: var(--dds-color-border-action-default);
  color: var(--dds-color-text-action-resting);
}

.item-text {
  text-align: start;
}

.item-text--inactive-link {
  text-decoration-color: transparent;
}
